module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image bg-trees full-height",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "block block-rounded animated fadeIn push-50-t",
    attrs: {
      "id": "registration-container"
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full block-content-narrow"
  }, [_c('h1', {
    staticClass: "h2 font-w600 push-20-t push-50"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo-complete.png"),
      "height": "58"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Please fill the following details to create a new forester account.")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal push-30-t push-30",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('wc-input', {
    attrs: {
      "label": "First Name"
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('wc-input', {
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = $$v
      },
      expression: "last_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password Confirmation"
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = $$v
      },
      expression: "password_confirmation"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                            Create Account\n                                        ")])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114090ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/register.vue
// module id = 812
// module chunks = 3